import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#FFF",
                d: "M12.133 3.5c5.413 0 9.8 4.388 9.8 9.8 0 2.207-.729 4.243-1.96 5.881l4.592 3.99c.328.286.363.783.078 1.112l-.172.198c-.286.328-.783.363-1.111.077l-4.622-4.017c-1.742 1.59-4.06 2.559-6.605 2.559-5.412 0-9.8-4.388-9.8-9.8 0-5.412 4.388-9.8 9.8-9.8zm0 1.838c-4.397 0-7.962 3.564-7.962 7.962s3.565 7.962 7.962 7.962c4.398 0 7.963-3.564 7.963-7.962s-3.565-7.963-7.963-7.963z",
                transform: "translate(-1290 -426) translate(96 400) translate(1176 8) translate(18 18)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }